import { request } from "../lib/requestHelper";

export const fetchAllArtisansService = async ({ page, limit }) => {
  const params = new URLSearchParams({ page, limit });
  return await request(`api/fetch-artisans?${params.toString()}`, { method: "GET" });
};

export const fetchFilteredArtisansService = async ({
  page,
  limit,
  filters,
}) => {
  const params = new URLSearchParams({
    page,
    limit,
    category: filters.category,
    priceRange: filters.priceRange,
    verifiedOnly: filters.verifiedOnly,
  });

  return await request(`api/filter-artisans?${params.toString()}`, { method: "GET" });
};

export const fetchFeaturedArtisansService = async () => {
  return await request("api/fetch-featured-artisans", { method: "GET" });
};

export const fetchSuggestedArtisansService = async () => {
  return await request("api/fetch-suggested-artisans", { method: "GET" });
};
